/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// by adding feature flag to this array you agree that this feature flag:
// * is expected to impact all performance metrics in Jira (page load, interactions, etc)
// * is expected to be short term

export const featureFlagsAddedToEVERYJiraEvent: Array<never> = [];
